import React from "react";
import PropTypes from "prop-types";
import * as PrimitiveAccordion from "@radix-ui/react-accordion";

export function Root({
  value,
  defaultValue,
  children,
  className,
  type,
  collapsible,
  onValueChange,
}) {
  return (
    <PrimitiveAccordion.Root
      defaultValue={defaultValue}
      type={type}
      collapsible={collapsible}
      value={value}
      onValueChange={onValueChange}
      className={className}
    >
      {children}
    </PrimitiveAccordion.Root>
  );
}

export function Item({ value, children, className }) {
  return (
    <PrimitiveAccordion.Item value={value} className={className}>
      {children}
    </PrimitiveAccordion.Item>
  );
}

export function Trigger({ children, className }) {
  return (
    <PrimitiveAccordion.Header className="flex">
      <PrimitiveAccordion.Trigger className={className}>
        {children}
      </PrimitiveAccordion.Trigger>
    </PrimitiveAccordion.Header>
  );
}

export function Content({ children, className }) {
  return (
    <PrimitiveAccordion.Content className={className}>
      {children}
    </PrimitiveAccordion.Content>
  );
}

Root.propTypes = {
  value: PropTypes.string,
  defaultValue: PropTypes.any,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  className: PropTypes.string,
  type: PropTypes.oneOf(["single", "multiple"]),
  collapsible: PropTypes.bool,
  onValueChange: PropTypes.func,
};

Root.defaultProps = {
  value: undefined,
  defaultValue: undefined,
  className: undefined,
  type: "single",
  collapsible: true,
  onValueChange: () => {},
};

Item.propTypes = {
  value: PropTypes.any.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  className: PropTypes.string,
};

Item.defaultProps = {
  className: undefined,
};

Trigger.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  className: PropTypes.string,
};

Trigger.defaultProps = {
  className: undefined,
};

Content.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  className: PropTypes.string,
};

Content.defaultProps = {
  className: undefined,
};
